module.exports = __webpack_public_path__ + "static/img/passo3.af7a9b5b.svg";